import user from './user/index';
import modules from './modules/index';
import category from './category/index';
import language from './language/index';
import langtest from './langtest/index';
import userTeacher from './userTeacher/index';
import userAdmin from './userAdmin/index';
import userStudent from './userStudent/index';
import software from './software/index';
import seatSetting from './seatSetting/index';
import teachPlace from './teachPlace/index';
import langVeriLimit from './langVeriLimit/index';
import diagnosisOpen from './diagnosisOpen/index';
import sysSetting from './sysSetting/index';
import std from './std/index';
import topicSet from './topicSet/index';
import lectureLesson from './lectureLesson/index';
import role from './role/index';
import reserveLimit from './reserveLimit/index';
import drYms from './drYms/index';
import teacherSchedule from './teacherSchedule/index';
import courseSchedule from './courseSchedule/index';
import teacherOnline from './teacherOnline/index';
import yms from './yms/index';
import teacherScheduleException from './teacherScheduleException/index';
import studentReservation from './studentReservation/index';
import studentReservationLecture from './studentReservationLecture/index';
import studentReservationSoftware from './studentReservationSoftware/index';
import studentResDiagRecord from './studentResDiagRecord/index';
import studentResTreatRecord from './studentResTreatRecord/index';
import files from './files/index';
import teacherLeaveMakeUp from './teacherLeaveMakeUp/index';
import questionSurvey from './questionSurvey/index';
import questionReply from './questionReply/index';
import satisfaction from './satisfaction/index';
import report from './report/index';
import news from './news/index';
import stdResTreatPlan from './stdResTreatPlan/index';
import styleSetting from './styleSetting/index';
import Import from './Import/index';
import common from './common/index';
import system from './system/index';
import wzuFcm from './wzuFcm/index';
import s18 from './s18/index';
import s1x from './s1x/index';
import s1y from './s1y/index';
import s1c from './s1c/index';
import s14 from './s14/index';
import s16 from './s16/index';
import s20 from './s20/index';
import s30 from './s30/index';
import s31 from './s31/index';
import s32 from './s32/index';
import s33 from './s33/index';
import s40 from './s40/index';
import s41 from './s41/index';
import s43 from './s43/index';
import s45 from './s45/index';
import s47 from './s47/index';
import s49 from './s49/index';
import s51 from './s51/index';
import s55 from './s55/index';
import s46 from './s46/index';
import s56 from './s56/index';
import s419 from './s419/index';
import s70 from './s70/index';
import s99 from './s99/index';

export default {
  user,
  modules,
  category,
  language,
  langtest,
  userTeacher,
  userAdmin,
  userStudent,
  software,
  seatSetting,
  teachPlace,
  langVeriLimit,
  diagnosisOpen,
  sysSetting,
  std,
  topicSet,
  lectureLesson,
  role,
  reserveLimit,
  drYms,
  teacherSchedule,
  courseSchedule,
  teacherOnline,
  yms,
  teacherScheduleException,
  studentReservation,
  studentReservationLecture,
  studentReservationSoftware,
  studentResDiagRecord,
  files,
  teacherLeaveMakeUp,
  questionSurvey,
  questionReply,
  satisfaction,
  studentResTreatRecord,
  report,
  news,
  stdResTreatPlan,
  styleSetting,
  Import,
  common,
  system,
  wzuFcm,
  s14,
  s16,
  s18,
  s1c,
  s1x,
  s1y,
  s20,
  s30,
  s31,
  s32,
  s33,
  s40,
  s41,
  s43,
  s45,
  s47,
  s49,
  s51,
  s55,
  s46,
  s56,
  s419,
  s70,
  s99,
};
